// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oBwk7C {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: space-between;
  gap: var(--spacing-2);
  width: 100%;
  padding-top: var(--spacing-1);
}

.PY8qfV {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.bmGKj8 {
  margin: 0;
  font-family: var(--font-family-base);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark);
}

.ufR8r3 {
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  flex-shrink: 0;
  align-self: flex-end;
  font-family: var(--font-family-base);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-160);
  color: var(--text-primary-medium);
  cursor: pointer;
  text-decoration: none;
}

.ufR8r3:hover {
  color: var(--text-primary-strong);
  text-decoration: underline;
}

.NMYRQ4 {
  position: fixed;
  right: 24px;
  top: 64px;
  left: initial;
  width: 320px;
  min-width: initial;
  transform: initial;
  z-index: 1000;
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/PatFacilitatorInfo/PatFacilitatorInfo.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,8BAA8B;EAC9B,qBAAqB;EACrB,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,cAAc;EACd,oBAAoB;EACpB,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,mCAAmC;EACnC,iCAAiC;EACjC,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;EACT,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;AACf","sourcesContent":[".container {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: var(--spacing-2);\n  width: 100%;\n  padding-top: var(--spacing-1);\n}\n\n.fields {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.field {\n  margin: 0;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-regular);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark);\n}\n\n.copyButton {\n  border: none;\n  background: none;\n  padding: 0;\n  margin: 0;\n  flex-shrink: 0;\n  align-self: flex-end;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-semibold);\n  line-height: var(--line-height-160);\n  color: var(--text-primary-medium);\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.copyButton:hover {\n  color: var(--text-primary-strong);\n  text-decoration: underline;\n}\n\n.alert {\n  position: fixed;\n  right: 24px;\n  top: 64px;\n  left: initial;\n  width: 320px;\n  min-width: initial;\n  transform: initial;\n  z-index: 1000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `oBwk7C`,
	"fields": `PY8qfV`,
	"field": `bmGKj8`,
	"copyButton": `ufR8r3`,
	"alert": `NMYRQ4`
};
module.exports = ___CSS_LOADER_EXPORT___;
